import {Component, ElementRef, ViewChild, ViewEncapsulation} from '@angular/core';

import {BaseComponent} from '../_base.component';
import {FormGridWithRows} from '../../../form.interface';
import Quill from 'quill';

/**
 * @ignore
 */
@Component({
  selector: 'uex-input-wysiwyg',
  templateUrl: './wysiwyg.component.html',
  host: {
    class: 'uex-input-wysiwyg'
  },
  encapsulation: ViewEncapsulation.None
})
export class InputWysiwygComponent extends BaseComponent<string> {
  @ViewChild('wysiwyg', {static: true}) editable: ElementRef;

  public getRows(): number {
    return (<FormGridWithRows>this.schema.grid).rows;
  }

  quillEditor;

  public ngOnInit() {
    setTimeout(() => {
      this.quillEditor = this.create('#textarea-' + this.schema.key);
      this.quillEditor.constructor.height = '150px';
      this.setQuillInstance(this.quillEditor);
    }, 50);
  }

  private _getToolbarContainer() {
    const baseOptions = [
      [{'header': [1, 2, 3, 4, 5, 6, false]}, 'bold', 'italic', 'underline', 'strike'],
      [{'list': 'ordered'}, {'list': 'bullet'}, {'align': []}],
      [{'indent': '-1'}, {'indent': '+1'}], ['link'],
    ];
    if (this.schema.toolbar) {
      baseOptions.push(this.schema.toolbar.container);
    }
    return baseOptions;
  }

  private _getToolbarHandlers() {
    if (this.schema.toolbar) {
      return this.schema.toolbar.handlers;
    }
  }

  public create(renderTo: string, style = '') {
    let quillEditor = null;
    const toolbarContainer = this._getToolbarContainer();
    const toolbarHandlers = this._getToolbarHandlers();
    const element = document.querySelector(renderTo);
    let elements;
    let container = null;
    if (element) {
      elements = Array.prototype.slice.call(document.querySelectorAll(renderTo));
    } else {
      elements = Array.prototype.slice.call(document.querySelectorAll('[data-quilljs]'));
    }
    elements.forEach(function (el) {
      if (element && el.hasAttribute('data-quilljs')) {
        return;
      }
      const type = el.type;
      let value = el.type;
      if (type === 'textarea') {
        value = el.value;
        container = document.createElement('div');
        container.innerHTML = value;
        container.id = `${element.id}-editor`;
        container.setAttribute('style', style);
        el.parentNode.insertBefore(container, el.nextSibling);
        el.style.display = 'none';
      } else {
        container = el;
      }
      quillEditor = new Quill(container, {
        theme: 'snow',
        modules: {
          toolbar: {
            container: toolbarContainer,
            handlers: toolbarHandlers
          },
        }
      });
    });
    quillEditor.on('text-change', function () {
      element.innerHTML = quillEditor.root.innerHTML;
    });
    return quillEditor;
  }

}
